import { render, staticRenderFns } from "./primary-column-modal.vue?vue&type=template&id=33e65f79&scoped=true&"
import script from "./primary-column-modal.vue?vue&type=script&lang=js&"
export * from "./primary-column-modal.vue?vue&type=script&lang=js&"
import style0 from "./primary-column-modal.vue?vue&type=style&index=0&id=33e65f79&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e65f79",
  null
  
)

export default component.exports